module.exports = __webpack_public_path__ + "assets/img/xs_logo.93ca4bc1.png";